import { Decoration, DecorationSet } from '@tiptap/pm/view';
import { s as styles } from '../hashtag-0d2a412a.js';
import { hashtagRegex } from '../const.js';

const hasLink = (node) => {
  return node.marks.map((mark) => mark.type.name).includes("link");
};
function findHashTag(doc) {
  const decorations = [];
  doc.descendants((node, position) => {
    if (!node.text) {
      return;
    }
    Array.from(node.text.matchAll(hashtagRegex)).forEach((match) => {
      const hash = match[0];
      let hashLength = hash.length;
      let index = match.index || 0;
      if (hash.startsWith(" ")) {
        index++;
        hashLength--;
      }
      const from = position + index;
      const to = from + hashLength;
      if (hasLink(node)) {
        return false;
      }
      const decoration = Decoration.inline(
        from,
        to,
        {
          class: styles.hashtag
        },
        { name: "hashtag" }
      );
      decorations.push(decoration);
    });
  });
  return DecorationSet.create(doc, decorations);
}

export { findHashTag as default };
//# sourceMappingURL=findHashTag.js.map
